module.exports = __webpack_public_path__ + "static/media/profile-11.17037411.png";